import { applyMiddleware, createStore as reduxCreateStore } from "redux"
import { rootReducer } from "./reducers"
import thunk from "redux-thunk"

const createStore = () => reduxCreateStore(rootReducer, applyMiddleware(thunk))
export default createStore
